import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteDisasterPayment($id: ID!) {
        deleteDisasterPayment(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
